module.exports = __webpack_public_path__ + "img/Image13.f165df1f.jpg";